<template>
    <div class="xbartable">
        <table border="0">
            <tr class="th">
                <td>{{ t('confirmation.details_list.table.unique_id_nocss') }}</td>
                <td>{{ t('confirmation.details_list.table.confirmation_type') }}</td>
                <td>{{ t('confirmation.details_list.table.entity_name') }}</td>
                <td>{{ t('confirmation.details_list.table.addressee_entity_name') }}</td>
                <td>{{ t('confirmation.details_list.table.balance_sheet_date') }}</td>
                <td>{{ t('confirmation.details_list.table.number_of_days_since_received') }}</td>
            </tr>
            <tr
                class="tr"
                v-for="(v, k) in tableData"
                :key="k">
                    <td>{{ v.uniqueId }}</td>
                    <td>{{ t(`confirmation_type._${v.isBank}`) }}</td>
                    <td>{{ v.confirmationEntityName }}</td>
                    <td>{{ v.addrEntityName }}</td>
                    <td>{{ v.balanceSheetDateStamp | formatDate }}</td>
                    <td>{{ v.daysOfReceivedAndProcessedByAddressees }}</td>
            </tr>
        </table>
    </div>
</template>
<script>
export default {
    name: 'XBTable',
    props: {
        tableData: {
            type: Array,
            default: () => {}
        }
    },
    methods: {
        t() {
            return window.vm.$t(...arguments)
        }
    }
}
</script>
<style scoped>
.xbartable {
    width: 100%;
    height: 100%;
}
.xbartable .th {
    height: 44px;
}
.xbartable .tr {
    padding-bottom: 10px;
}
.xbartable tr td {
    padding-right: 10px;
}
</style>